export default "__VITE_ASSET__Dpx45QBB__"